// extracted by mini-css-extract-plugin
export default {"custom_title":"SampleAbstract_custom_title__F9uRk"};